module.exports = __webpack_public_path__ + "static/media/legendaryxmasconcert.7c05b8b9.png";